/* Página de licencias.
 *
 * La autorización la decide el endpoint, no esta página: se pide a
 * /apps/licencias/licencias y si contesta login_required se muestra el
 * acceso. No se confía en nada del lado del cliente para decidir qué
 * mostrar, y no se pinta ninguna licencia que no haya venido del Worker.
 *
 * Las URLs son relativas a propósito: así la petición viaja al mismo
 * dominio donde está navegando el cliente y lleva su sesión. Con el
 * dominio myshopify escrito a mano no habría cookie y CORS lo bloquearía.
 */
(function () {
  'use strict';

  var API = '/apps/licencias';

  function t(es, en) {
    return document.documentElement.lang === 'es' ? es : en;
  }

  function fecha(ms) {
    if (!ms) return '';
    try {
      return new Date(ms).toLocaleDateString(
        document.documentElement.lang === 'es' ? 'es-UY' : 'en-US',
        { year: 'numeric', month: 'short', day: 'numeric' }
      );
    } catch (e) {
      return '';
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // textContent, nunca innerHTML
    return n;
  }

  function init() {
    var root = document.querySelector('[data-di-licenses]');
    if (!root) return;

    var slot = root.querySelector('[data-di-licenses-body]');

    function estado(mensaje, cta) {
      slot.textContent = '';
      var box = el('div', 'di-lic__state');
      box.appendChild(el('p', 'di-lic__msg', mensaje));
      if (cta) box.appendChild(cta);
      slot.appendChild(box);
    }

    function botonLogin() {
      var a = el('a', 'di-btn di-btn--accent di-buylink di-buylink--sm',
        t('Ingresar', 'Log in'));
      a.href = root.dataset.diLoginUrl || '/account';
      return a;
    }

    function botonComprar() {
      var url = root.dataset.diProductUrl;
      if (!url) return null;
      var a = el('a', 'di-btn di-btn--accent di-buylink di-buylink--sm',
        t('Ver SID', 'Explore SID'));
      a.href = url;
      return a;
    }

    /* ---------------------------------------------------------- render */

    function pintar(licencias) {
      slot.textContent = '';

      if (!licencias.length) {
        estado(t('Todavía no tenés licencias en esta cuenta.',
                 'No licenses on this account yet.'), botonComprar());
        return;
      }

      licencias.forEach(function (lic) {
        slot.appendChild(tarjeta(lic));
      });
    }

    function tarjeta(lic) {
      var card = el('article', 'di-lic__card');

      var head = el('div', 'di-lic__head');
      var izq = el('div');
      izq.appendChild(el('p', 'di-lic__product', lic.product || 'SID'));
      var k = el('p', 'di-lic__key', lic.key);
      k.setAttribute('data-di-no-i18n', '');
      izq.appendChild(k);
      head.appendChild(izq);

      var slots = el('p', 'di-lic__slots',
        lic.used + ' / ' + lic.seats + ' ' + t('máquinas', 'machines'));
      slots.setAttribute('data-di-no-i18n', '');
      head.appendChild(slots);
      card.appendChild(head);

      if (!lic.machines.length) {
        card.appendChild(el('p', 'di-lic__empty',
          t('Ninguna máquina activada todavía. Activá desde el plugin con esta clave.',
            'No machines activated yet. Activate from the plugin using this key.')));
        return card;
      }

      var lista = el('div', 'di-lic__machines');
      lic.machines.forEach(function (m) {
        lista.appendChild(fila(lic, m));
      });
      card.appendChild(lista);
      return card;
    }

    function fila(lic, m) {
      var row = el('div', 'di-lic__machine');

      var info = el('div');
      var id = el('p', 'di-lic__mid', m.label || '—');
      id.setAttribute('data-di-no-i18n', '');
      info.appendChild(id);
      info.appendChild(el('p', 'di-lic__date',
        t('Activada el ', 'Activated ') + fecha(m.at)));
      row.appendChild(info);

      var acciones = el('div', 'di-lic__actions');
      var liberar = el('button', 'di-lic__release', t('Liberar', 'Release'));
      liberar.type = 'button';

      liberar.addEventListener('click', function () {
        // Confirmación en dos pasos: liberar es destructivo y el botón
        // queda al lado de datos que el usuario está leyendo.
        acciones.textContent = '';
        var si = el('button', 'di-lic__release di-lic__release--confirm',
          t('Confirmar', 'Confirm'));
        si.type = 'button';
        var no = el('button', 'di-lic__cancel', t('Cancelar', 'Cancel'));
        no.type = 'button';

        no.addEventListener('click', function () {
          acciones.textContent = '';
          acciones.appendChild(liberar);
        });

        si.addEventListener('click', function () {
          si.disabled = true;
          no.disabled = true;
          si.textContent = t('Liberando…', 'Releasing…');
          liberarMaquina(lic.key, m.machine_id, acciones);
        });

        acciones.appendChild(si);
        acciones.appendChild(no);
      });

      acciones.appendChild(liberar);
      row.appendChild(acciones);
      return row;
    }

    /* ------------------------------------------------------------ red */

    function liberarMaquina(key, machineId, acciones) {
      fetch(API + '/deactivate', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ key: key, machine_id: machineId }),
      })
        .then(function (r) {
          if (r.status === 403) throw new Error('forbidden');
          if (!r.ok) throw new Error('http_' + r.status);
          return r.json();
        })
        .then(function () {
          cargar();   // recarga la lista: el slot queda libre
        })
        .catch(function (err) {
          acciones.textContent = '';
          var e = el('p', 'di-lic__error',
            err.message === 'forbidden'
              ? t('No se pudo liberar.', 'Could not release.')
              : t('Error de conexión.', 'Connection error.'));
          acciones.appendChild(e);
          setTimeout(cargar, 2500);
        });
    }

    function cargar() {
      estado(t('Cargando…', 'Loading…'));

      fetch(API + '/licencias', { headers: { accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 403) throw new Error('login_required');
          if (!r.ok) throw new Error('http_' + r.status);
          return r.json();
        })
        .then(function (data) {
          pintar(data.licenses || []);
        })
        .catch(function (err) {
          if (err.message === 'login_required') {
            estado(t('Iniciá sesión para ver tus licencias.',
                     'Log in to see your licenses.'), botonLogin());
          } else {
            estado(t('No pudimos cargar tus licencias. Probá de nuevo en un momento.',
                     'We could not load your licenses. Try again in a moment.'));
          }
        });
    }

    cargar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
